import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';

type UseDeletePhysicalSettlementConfigs = {
  onReject?: UseMutationConfig<any>['onReject'];
  onSuccess?: UseMutationConfig<any>['onSuccess'];
};

export default function useDeletePhysicalSettlement({
  onSuccess,
  onReject,
}: UseDeletePhysicalSettlementConfigs) {
  const {
    execute: deletePhysicalSettlement,
    isPending: isLoadingDeletePhysicalSettlement,
    ...query
  } = useMutation(API.deletePhysicalSettlement, {
    onSuccess,
    onReject,
  });

  return {
    deletePhysicalSettlement,
    isLoadingDeletePhysicalSettlement,
    ...query,
  };
}
